<div class="c-survey__section survey-choices">
  <h2 class="c-survey__question">{{dialogObj.Title | translate}}</h2>
  <span>
    {{dialogObj.Description | translate}}
  </span>
</div>
